<template>
  <div>
    <div class="bg" />
    <div class="pr">
      <div class="w1200 newBox">
        <el-menu
          :default-active="activeIndex"
          class="newNav pr"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="wconcept">
            <router-link to="/warehouse/wconcept">
              医药共享仓
            </router-link>
          </el-menu-item>
          <!-- <el-menu-item index="wflow"><router-link to="/warehouse/wflow">运作流程</router-link></el-menu-item> -->
          <el-menu-item index="wstage">
            <router-link to="/warehouse/wstage">
              所处阶段
            </router-link>
          </el-menu-item>
        </el-menu>
      </div>
    </div>
    <router-view />
      
    <div class="wconcept">
      <router-view
        name="wconcept"
        :key="$route.fullPath"
      />
    </div>
    <div class="qyxwxq">
      <router-view
        name="qyxwxq"
        :key="$route.fullPath"
      />
    </div>
    <router-view
      name="wflow"
      :key="$route.fullPath"
    />
    <router-view
      name="wstage"
      :key="$route.fullPath"
    />
    <div
      v-for="(item) in value"
      :key="item.id"
      v-html="item.text"
    />
    <div>{{ value }}</div>
  </div>
</template>

<script>
import { request } from '../../assets/utils/request'

export default {
    data() {
        return {
            list: [],
            value: '',
            activeIndex: ''
        }
    },
    watch: {
        activeIndex(){
            var path = this.$route.path.split('/')
            this.activeIndex = path[2]
        }
    },
    methods: {
        getList() {
            var that = this;
            request('/mocks/news/news.json',{
                onSuccess(data) {
                    try {
                        data = JSON.parse(data)
                        that.list = data
                    } catch (e) {
                        that.list = [];
                    }
                }
            })
        },
        handleSelect() {

        },
        getActiveIndex() {
            var path = this.$route.path.split('/')
            if(path !== "" ){
                this.activeIndex = path[2]
            }else{
            }
        }
    },
    created(){
    },
    mounted() {
        this.getList();
        this.getActiveIndex();
    }
}
</script>

<style scoped>
    .bg{
        background: url('../../assets/images/bg.jpg') center center no-repeat;
        width: 100%;
        height: 400px;
    }
    .w1200.newBox{
        position: absolute;
        background: url('../../assets/images/nav.png') center center no-repeat;
        background-size: contain;
        height: 85px;
        top: -60px;
        left: 50%;
        margin-left: -600px;
    }
    .newBox .newNav{
        background: transparent;
        /* width: 408px; 三个模块 */
        width: 272px;
        margin: 0 auto;
    }
    .newBox .newNav .el-menu-item{
        height: 95px!important;
        line-height: 95px!important;
        font-size: 16px;
        position: relative;
        top: -10px;
        width: 136px;
        text-align: center;
        color: #fff;
        padding: 0;
    }
    .newBox .newNav .el-menu-item:hover{
        background: #5bb62d;
        color: #fff!important;
    }
    .newBox .el-menu--horizontal>.el-menu-item.is-active{
        background: #5bb62d;
        color: #fff!important;
    }
    a{
        text-decoration: none;
    }
    .el-menu-item a{
        display: block;
        padding: 20 0;
    }
</style>